module.exports = __webpack_public_path__ + "14_hair_brown.78f3069f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/14_hair_brown.png
// module id = Nbrd
// module chunks = 0